import { render, staticRenderFns } from "./eventmodal.vue?vue&type=template&id=b3b75802"
import script from "./eventmodal.vue?vue&type=script&lang=js"
export * from "./eventmodal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports